import { useTranslation } from 'react-i18next'

import { WarningIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

const DisabledTriggerChip = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Chip
      label={t('Trigger desactivado — Smart Tracking')}
      backgroundColor={theme.colors.warning.surface}
      color={theme.colors.danger.onSurface}
      Icon={() => <WarningIcon size={16} weight="fill" color={theme.colors.accent.hover} />}
    />
  )
}

export default DisabledTriggerChip
